// © Microsoft Corporation. All rights reserved.

import { TelemetryBehaviorType, TelemetryType } from "@msnews/telemetry-contracts";

import { genericTelemetryClickDispatcher } from "../../Social.telemetry";

export interface SortBoxTelemetryObjects {
    sortItems: any;
}

export const sortBoxTelemetryContracts = {
    /** Scenario 1 from ProfileComments
     * id: traceId || commentId
     * type: Profile or Comment comes from parent
    */
    sortItem: {
        name: "Sort",
        behavior: TelemetryBehaviorType.Sort
    }
};

export const sortBoxTelemetryActionDispatchers = {
    /** Used for: Scenario 3a and Scenario 4a */
    genericClicked: genericTelemetryClickDispatcher
};